import PropTypes from 'prop-types';
import React, { useState, useEffect, useMemo } from 'react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const TypingEffect = ({ isShowTypingEffect, markdown }) => {
  const tempDisableTypeEffect = true;
  const [typedContent, setTypedContent] = useState('');
  const [currentLetterIndex, setCurrentLetterIndex] = useState(0);

  const lines = useMemo(() => (typeof markdown === 'string' ? markdown : ''), [markdown]);

  useEffect(() => {
    if (isShowTypingEffect && currentLetterIndex < lines.length) {
      const speed = calculateSpeed(lines.length);
      const timer = setTimeout(() => {
        setTypedContent((prev) => prev + lines[currentLetterIndex]);
        setCurrentLetterIndex((prev) => prev + 1);
      }, speed);

      return () => clearTimeout(timer);
    }
    return () => null;
  }, [currentLetterIndex, lines, isShowTypingEffect]);

  const calculateSpeed = (contentLength) => {
    if (contentLength > 800) {
      return 10; // Faster for very long content
    }
    if (contentLength < 50) {
      return 10; // Slower for short content
    }
    return 10; // Default speed
  };

  const content = isShowTypingEffect && !tempDisableTypeEffect ? typedContent : markdown;

  return (
    <div className="typewriter-container">
      <div className="typewriter-line">
        {/* {isShowTypingEffect && !tempDisableTypeEffect ? (
          <Markdown remarkPlugins={[remarkGfm]}>{typedContent}</Markdown>
        ) : (
          <Markdown remarkPlugins={[remarkGfm]}>{markdown}</Markdown>
        )} */}

        <Markdown
          remarkPlugins={[remarkGfm]}
          components={{
            a: ({ node, children, ...props }) => (
              <a {...props} target="_blank" rel="noopener noreferrer">
                {children}
              </a>
            ),
          }}
        >
          {content}
        </Markdown>

      </div>
    </div>
  );
};

TypingEffect.propTypes = {
  isShowTypingEffect: PropTypes.bool,
  markdown: PropTypes.any,
};

export default TypingEffect;